var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconDatingTarget1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.93 9.1a1.9 1.9 0 0 0-2.751 0L12 10.314 10.821 9.1a1.9 1.9 0 0 0-2.751 0 2.06 2.06 0 0 0 0 2.845l3.511 3.631a.579.579 0 0 0 .838 0l3.511-3.636a2.06 2.06 0 0 0 0-2.84Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12a9 9 0 1 0 18 0 9 9 0 1 0-18 0Zm9-10.5v3.75m0 13.5v3.75M22.5 12h-3.75m-13.5 0H1.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconDatingTarget1);
export default __webpack_public_path__ + "static/media/streamline-icon-dating-target-1.2da419ad.svg";
export { ForwardRef as ReactComponent };